module.exports = __webpack_public_path__ + "img/gntech_main1.b0ce0ef4.jpg";